import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * `/agenda?profissional=<userId>` deixa a agenda filtrada naquele profissional.
 *
 * Existe pra "Ver agenda" dos cartões da Equipe ter um destino de verdade: mandar pra `/agenda`
 * seca abriria o filtro que estivesse salvo da última vez, que provavelmente não é o profissional
 * que a pessoa acabou de clicar. Escreve no MESMO filtro persistido da agenda (via `setIds`), em
 * vez de mexer no localStorage por fora.
 */
export function useProfissionalPorUrl(setIds: (ids: string[]) => void) {
  const location = useLocation();
  const navigate = useNavigate();
  const id = new URLSearchParams(location.search).get("profissional");
  const jaAplicou = useRef<string | null>(null);

  useEffect(() => {
    if (!id || jaAplicou.current === id) return;
    jaAplicou.current = id;
    setIds([id]);
    // Limpa o parâmetro: sem isso um F5 reimporia o filtro mesmo depois de o usuário trocá-lo.
    navigate(location.pathname, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
}
